<script setup lang="ts">
import type { ConferenceContest, PropType, Result, Theme, E2E } from "@/types";
import { computed } from "vue";

const props = defineProps({
  result: {
    type: Object as PropType<Result>,
    required: true,
  },
  votingRoundReport: {
    type: Object as PropType<E2E.VotingRoundReport>,
    required: true,
  },
  contest: {
    type: Object as PropType<ConferenceContest>,
    required: true,
  },
  theme: {
    type: String as PropType<Theme>,
    default: "dark",
  },
});

const counts = computed(() => {
  if (!props.result.resultData) return {};
  return props.result.resultData.optionCounts;
});

const totalCount = computed(() => {
  if (props.contest.disregardBlankVotes) {
    return Object.entries(counts)
      .filter(([reference, _count]) => reference.toString() !== "blank")
      .reduce((sum: number, [_reference, count]: any[]) => sum + count, 0);
  } else if (props.contest.consensusRequired && props.contest.countUnvoicedVotesAsBlank) {
    return props.contest.disregardVoterWeight
      ? props.result.voterCounts.activeEligiblesOrVoted
      : props.result.voterCounts.activeEligiblesOrVotedWeight;
  } else {
    const excludedOptions = props.result.resultData?.exclusiveOptions.filter(reference => reference !== "blank")

    return Object.entries(props.result.resultData?.optionCounts)
      .filter(([reference, _count]) => !excludedOptions.includes(reference))
      .reduce((sum: number, [_reference, count]: any[]) => sum + count, 0);
  }
});
</script>

<template>
  <AVDhondtSummary
    :result="result.resultDataForDisplay"
    :total-count="totalCount"
    :distribution-number="result.resultData.distributionNo"
    :hide-tied="!votingRoundReport.colorTied"
    :hide-elected="!votingRoundReport.colorElected"
    :seats="contest.seats ?? 1"
    :vote-counts="result.voterCounts"
  />
</template>
